// Fichier généré. Ne pas éditer à la main.

export const THEME = {
  light: {
    small: {
      brand: 'default',
      mode: 'light',
      breakpoint: 'small',
      colors: {
        black: '#161616',
        'border.brand': '#005A5D',
        'border.brand-alt': '#B8ECE0',
        'border.disabled': '#25252614',
        'border.divider': '#2525261F',
        'border.error': '#BE171B',
        'border.focused': '#88DDCC',
        'border.info': '#2C6CBF',
        'border.interactive': '#1EB8A6',
        'border.inverse.disabled': '#FEFEFD66',
        'border.inverse.divider': '#FEFEFD33',
        'border.inverse.interactive': '#88DDCC',
        'border.inverse.primary': '#FFFFFF',
        'border.inverse.secondary': '#FEFEFD66',
        'border.inverse.selected': '#88DDCC',
        'border.inverse.strong': '#FFFFFF',
        'border.primary': '#25252666',
        'border.secondary': '#25252629',
        'border.secondary-1.default': '#CDF496',
        'border.secondary-1.strong': '#325017',
        'border.secondary-1.subtle': '#F6FDE8',
        'border.secondary-2.default': '#EDD441',
        'border.secondary-2.strong': '#6A4019',
        'border.secondary-2.subtle': '#FCFBEA',
        'border.secondary-3.default': '#FFAD54',
        'border.secondary-3.strong': '#7E3410',
        'border.secondary-3.subtle': '#FFF8ED',
        'border.secondary-4.default': '#FFA9AB',
        'border.secondary-4.strong': '#3E2D30',
        'border.secondary-4.subtle': '#FFF7F7',
        'border.secondary-5.default': '#A0A7FF',
        'border.secondary-5.strong': '#2B2C41',
        'border.secondary-5.subtle': '#F6F7FF',
        'border.selected': '#1EB8A6',
        'border.strong': '#161616',
        'border.success': '#5B9D13',
        'border.warning': '#BB8713',
        'component.button.bg.hover': '#FEFEFD33',
        'component.button.bg.inverted': '#FFFFFF',
        'component.button.bg.pressed': '#25252666',
        'component.button.bg.primary': '#005A5D',
        'component.button.bg.secondary': '#B8ECE0',
        'component.button.bg.tertiary': '#F5F4F1',
        'component.button.bg.transparent': '#25252699',
        'component.button.border.tertiary': '#25252629',
        'component.button.icon.tertiary': '#005A5D',
        'component.button.label.tertiary': '#005A5D',
        'gradient.Bottom Tab Bar - End': '#FEFEFDB2',
        'gradient.Bottom Tab Bar - Start': '#FEFEFD00',
        'gradient.primary': '#FFFFFF00',
        'icon.brand': '#005A5D',
        'icon.brand-alt': '#B8ECE0',
        'icon.disabled': '#25252666',
        'icon.error': '#BE171B',
        'icon.info': '#2C6CBF',
        'icon.interactive': '#1EB8A6',
        'icon.inverse.disabled': '#FEFEFD99',
        'icon.inverse.interactive': '#88DDCC',
        'icon.inverse.primary': '#FFFFFF',
        'icon.inverse.secondary': '#FEFEFD',
        'icon.primary': '#161616',
        'icon.secondary': '#676666',
        'icon.secondary-1.default': '#CDF496',
        'icon.secondary-1.strong': '#325017',
        'icon.secondary-1.subtle': '#F6FDE8',
        'icon.secondary-2.default': '#EDD441',
        'icon.secondary-2.strong': '#6A4019',
        'icon.secondary-2.subtle': '#FCFBEA',
        'icon.secondary-3.default': '#FFAD54',
        'icon.secondary-3.strong': '#7E3410',
        'icon.secondary-3.subtle': '#FFF8ED',
        'icon.secondary-4.default': '#FFA9AB',
        'icon.secondary-4.strong': '#3E2D30',
        'icon.secondary-4.subtle': '#FFF7F7',
        'icon.secondary-5.default': '#A0A7FF',
        'icon.secondary-5.strong': '#2B2C41',
        'icon.secondary-5.subtle': '#F6F7FF',
        'icon.success': '#5B9D13',
        'icon.tertiary': '#C1C0BC',
        'icon.warning': '#BB8713',
        page: '#FEFEFD',
        'shadow.inner': '#FEFEFD66',
        'shadow.strong': '#25252629',
        'shadow.subtle': '#25252614',
        'state-layer.hover': '#25252614',
        'state-layer.hover-alt': '#25252614',
        'state-layer.hover-brand': '#B8ECE033',
        'state-layer.hover-on-color': '#25252633',
        'state-layer.inverse.hover': '#FEFEFD14',
        'state-layer.inverse.hover-brand': '#B8ECE033',
        'state-layer.inverse.hover-on-color': '#FEFEFD33',
        'state-layer.inverse.press': '#FEFEFD29',
        'state-layer.inverse.press-brand': '#B8ECE066',
        'state-layer.inverse.press-on-color': '#25252666',
        'state-layer.press': '#25252629',
        'state-layer.press-alt': '#25252629',
        'state-layer.press-brand': '#B8ECE066',
        'state-layer.press-on-color': '#25252666',
        'surface.brand.bold': '#003133',
        'surface.brand.bold-alt': '#00393D',
        'surface.brand.default': '#1EB8A6',
        'surface.brand.secondary-1.default': '#CDF496',
        'surface.brand.secondary-1.strong': '#325017',
        'surface.brand.secondary-1.subtle': '#E8FACD',
        'surface.brand.secondary-2.default': '#EDD441',
        'surface.brand.secondary-2.strong': '#6A4019',
        'surface.brand.secondary-2.subtle': '#F9F6C8',
        'surface.brand.secondary-3.default': '#FFAD54',
        'surface.brand.secondary-3.strong': '#7E3410',
        'surface.brand.secondary-3.subtle': '#FFF0D4',
        'surface.brand.secondary-4.default': '#FFA9AB',
        'surface.brand.secondary-4.strong': '#3E2D30',
        'surface.brand.secondary-4.subtle': '#FFEEEE',
        'surface.brand.secondary-5.default': '#A0A7FF',
        'surface.brand.secondary-5.strong': '#2B2C41',
        'surface.brand.secondary-5.subtle': '#ECEDFF',
        'surface.brand.strong': '#005A5D',
        'surface.brand.strong-alt': '#005A5D',
        'surface.brand.subtle': '#EDF8F5',
        'surface.default': '#FFFFFF',
        'surface.disabled': '#2525261F',
        'surface.error.default': '#BE171B',
        'surface.error.subtle': '#FFE1E2',
        'surface.info.default': '#255594',
        'surface.info.subtle': '#D6E6FB',
        'surface.inverse.default': '#161616',
        'surface.inverse.disabled': '#FEFEFD33',
        'surface.inverse.primary-neutral': '#959492',
        'surface.inverse.secondary-neutral': '#C1C0BC',
        'surface.inverse.tertiary-neutral': '#EEECE7',
        'surface.overlay': '#25252666',
        'surface.primary': '#EDF8F5',
        'surface.primary-alt': '#ECFFFE',
        'surface.primary-neutral': '#F8F7F5',
        'surface.secondary': '#D9F2EB',
        'surface.secondary-alt': '#BDFDFF',
        'surface.secondary-neutral': '#F5F4F1',
        'surface.selected': '#EDF8F5',
        'surface.strong-neutral': '#3B3A3C',
        'surface.success.default': '#457714',
        'surface.success.subtle': '#E8FACD',
        'surface.tertiary': '#B8ECE0',
        'surface.tertiary-alt': '#7BFBFF',
        'surface.tertiary-neutral': '#F1F0EC',
        'surface.warning.default': '#956213',
        'surface.warning.subtle': '#F9F6C8',
        'text.brand': '#005A5D',
        'text.brand-alt': '#B8ECE0',
        'text.disabled': '#25252666',
        'text.emphasized': '#08817D',
        'text.error': '#BE171B',
        'text.info': '#2C6CBF',
        'text.interactive': '#1EB8A6',
        'text.inverse.disabled': '#FEFEFD66',
        'text.inverse.interactive': '#88DDCC',
        'text.inverse.primary': '#FFFFFF',
        'text.inverse.secondary': '#FEFEFDCC',
        'text.placeholder': '#959492',
        'text.positive': '#457714',
        'text.primary': '#161616',
        'text.secondary': '#676666',
        'text.secondary-1.default': '#CDF496',
        'text.secondary-1.strong': '#325017',
        'text.secondary-1.subtle': '#F6FDE8',
        'text.secondary-2.default': '#EDD441',
        'text.secondary-2.strong': '#6A4019',
        'text.secondary-2.subtle': '#FCFBEA',
        'text.secondary-3.default': '#FFAD54',
        'text.secondary-3.strong': '#7E3410',
        'text.secondary-3.subtle': '#FFF8ED',
        'text.secondary-4.default': '#FFA9AB',
        'text.secondary-4.strong': '#3E2D30',
        'text.secondary-4.subtle': '#FFF7F7',
        'text.secondary-5.default': '#A0A7FF',
        'text.secondary-5.strong': '#2B2C41',
        'text.secondary-5.subtle': '#F6F7FF',
        'text.warning': '#BB8713',
        white: '#FFFFFF',
        'white-label.accent.icon.on-brand-accent': '#FFFFFF',
        'white-label.accent.surface': '#005A5D',
        'white-label.accent.text.on-brand-accent': '#FFFFFF',
        'white-label.footer.footer-bg': '#005A5D',
        'white-label.header.bg': '#FFFFFF',
        'white-label.header.on-header': '#161616',
        'white-label.headerSubtext': '#FFFFFF',
        'white-label.highlight': '#FFFFFF',
        'white-label.highlightText': '#FFFFFF',
        'white-label.notificationLogoBackground': '#FFFFFF',
        'white-label.publish-button.bg.header-bar': '#005A5D',
        'white-label.publish-button.bg.mobile-bottom-tab-bar': '#005A5D',
        'white-label.publish-button.icon.header-bar': '#FFFFFF',
        'white-label.publish-button.icon.mobile-bottom-tab-bar': '#FFFFFF',
        'white-label.publish-button.label.primary': '#FFFFFF',
        'white-label.splash': '#B8ECE0',
      },
      responsive: {
        'border-width.bold': '4',
        'border-width.emphasized': '2',
        'border-width.standard': '1.5',
        'border-width.subtle': '1',
        'radius.component.fields.input': '16',
        'radius.component.publish-button.button-radius': '1000',
        'radius.full': '1000',
        'radius.lg': '16',
        'radius.md': '12',
        'radius.none': '0',
        'radius.sm': '8',
        'radius.xl': '24',
        'radius.xs': '4',
        'radius.xxl': '32',
        'radius.xxs': '2',
        'sizing.body.max-width': '767',
        'sizing.body.min-width': '320',
        'sizing.component.button.height.large': '56',
        'sizing.component.button.height.large-icn-button': '48',
        'sizing.component.button.height.medium': '40',
        'sizing.component.button.height.small': '32',
        'sizing.component.header.max-width': '767',
        'sizing.component.header.min-width': '320',
        'sizing.general.0': '0',
        'sizing.general.x0,25': '1',
        'sizing.general.x0,5': '2',
        'sizing.general.x1': '4',
        'sizing.general.x10': '40',
        'sizing.general.x100': '400',
        'sizing.general.x12': '48',
        'sizing.general.x120': '480',
        'sizing.general.x14': '56',
        'sizing.general.x140': '560',
        'sizing.general.x150': '600',
        'sizing.general.x16': '64',
        'sizing.general.x160': '640',
        'sizing.general.x18': '72',
        'sizing.general.x180': '720',
        'sizing.general.x2': '8',
        'sizing.general.x20': '80',
        'sizing.general.x200': '800',
        'sizing.general.x22': '88',
        'sizing.general.x24': '96',
        'sizing.general.x3': '12',
        'sizing.general.x30': '120',
        'sizing.general.x36': '144',
        'sizing.general.x4': '16',
        'sizing.general.x40': '160',
        'sizing.general.x5': '20',
        'sizing.general.x50': '200',
        'sizing.general.x6': '24',
        'sizing.general.x60': '240',
        'sizing.general.x7': '28',
        'sizing.general.x70': '280',
        'sizing.general.x8': '32',
        'sizing.general.x80': '320',
        'sizing.general.x90': '360',
        'sizing.icon.default': '24',
        'sizing.icon.lg': '32',
        'sizing.icon.s': '16',
        'sizing.icon.sm': '20',
        'sizing.icon.xl': '48',
        'sizing.icon.xs': '12',
        'spacing.general.0': '0',
        'spacing.general.x0,5': '2',
        'spacing.general.x1': '4',
        'spacing.general.x10': '40',
        'spacing.general.x12': '48',
        'spacing.general.x14': '56',
        'spacing.general.x16': '64',
        'spacing.general.x18': '72',
        'spacing.general.x2': '8',
        'spacing.general.x20': '80',
        'spacing.general.x22': '88',
        'spacing.general.x24': '96',
        'spacing.general.x3': '12',
        'spacing.general.x30': '120',
        'spacing.general.x36': '144',
        'spacing.general.x4': '16',
        'spacing.general.x5': '20',
        'spacing.general.x6': '24',
        'spacing.general.x7': '28',
        'spacing.general.x8': '32',
        'spacing.semantic.line-height-fix': '2',
        'spacing.semantic.page-margin': '16',
        'typography.font-size.body.base': '16',
        'typography.font-size.body.caption': '10',
        'typography.font-size.body.large': '18',
        'typography.font-size.body.small': '14',
        'typography.font-size.body.x-large': '20',
        'typography.font-size.body.x-small': '12',
        'typography.font-size.header.display 1': '48',
        'typography.font-size.header.display 2': '56',
        'typography.font-size.header.large': '40',
        'typography.font-size.header.medium': '28',
        'typography.font-size.header.small': '24',
        'typography.font-size.header.x-small': '20',
        'typography.font-size.link.link-base': '16',
        'typography.font-size.link.link-large': '20',
        'typography.font-size.link.link-small': '14',
        'typography.letter-spacing.body.base': '0',
        'typography.letter-spacing.body.caption': '0',
        'typography.letter-spacing.body.large': '0',
        'typography.letter-spacing.body.small': '0',
        'typography.letter-spacing.body.x-large': '0',
        'typography.letter-spacing.body.x-small': '0',
        'typography.letter-spacing.header.display 1': '0',
        'typography.letter-spacing.header.display 2': '0',
        'typography.letter-spacing.header.large': '0',
        'typography.letter-spacing.header.medium': '0',
        'typography.letter-spacing.header.small': '0',
        'typography.letter-spacing.header.x-small': '0',
      },
      styles: {
        header: {
          'display-2': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '900',
              fontSize: '56',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'display-1': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '900',
              fontSize: '48',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          large: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '40',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '40', letterSpacing: '0', lineHeight: 'normal' },
          },
          medium: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '28',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'medium-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '28', letterSpacing: '0', lineHeight: 'normal' },
          },
          small: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '24',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'small-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '24', letterSpacing: '0', lineHeight: 'normal' },
          },
          'x-small': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '20', letterSpacing: '0', lineHeight: 'normal' },
          },
        },
        body: {
          'x-large': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-large-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          large: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          base: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          small: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'small-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
        },
        caption: {
          caption: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '10',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'caption-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '10',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'caption-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '10',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
        },
        link: {
          'link-large': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-base': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-small': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
        },
      },
    },
    medium: {
      brand: 'default',
      mode: 'light',
      breakpoint: 'medium',
      colors: {
        black: '#161616',
        'border.brand': '#005A5D',
        'border.brand-alt': '#B8ECE0',
        'border.disabled': '#25252614',
        'border.divider': '#2525261F',
        'border.error': '#BE171B',
        'border.focused': '#88DDCC',
        'border.info': '#2C6CBF',
        'border.interactive': '#1EB8A6',
        'border.inverse.disabled': '#FEFEFD66',
        'border.inverse.divider': '#FEFEFD33',
        'border.inverse.interactive': '#88DDCC',
        'border.inverse.primary': '#FFFFFF',
        'border.inverse.secondary': '#FEFEFD66',
        'border.inverse.selected': '#88DDCC',
        'border.inverse.strong': '#FFFFFF',
        'border.primary': '#25252666',
        'border.secondary': '#25252629',
        'border.secondary-1.default': '#CDF496',
        'border.secondary-1.strong': '#325017',
        'border.secondary-1.subtle': '#F6FDE8',
        'border.secondary-2.default': '#EDD441',
        'border.secondary-2.strong': '#6A4019',
        'border.secondary-2.subtle': '#FCFBEA',
        'border.secondary-3.default': '#FFAD54',
        'border.secondary-3.strong': '#7E3410',
        'border.secondary-3.subtle': '#FFF8ED',
        'border.secondary-4.default': '#FFA9AB',
        'border.secondary-4.strong': '#3E2D30',
        'border.secondary-4.subtle': '#FFF7F7',
        'border.secondary-5.default': '#A0A7FF',
        'border.secondary-5.strong': '#2B2C41',
        'border.secondary-5.subtle': '#F6F7FF',
        'border.selected': '#1EB8A6',
        'border.strong': '#161616',
        'border.success': '#5B9D13',
        'border.warning': '#BB8713',
        'component.button.bg.hover': '#FEFEFD33',
        'component.button.bg.inverted': '#FFFFFF',
        'component.button.bg.pressed': '#25252666',
        'component.button.bg.primary': '#005A5D',
        'component.button.bg.secondary': '#B8ECE0',
        'component.button.bg.tertiary': '#F5F4F1',
        'component.button.bg.transparent': '#25252699',
        'component.button.border.tertiary': '#25252629',
        'component.button.icon.tertiary': '#005A5D',
        'component.button.label.tertiary': '#005A5D',
        'gradient.Bottom Tab Bar - End': '#FEFEFDB2',
        'gradient.Bottom Tab Bar - Start': '#FEFEFD00',
        'gradient.primary': '#FFFFFF00',
        'icon.brand': '#005A5D',
        'icon.brand-alt': '#B8ECE0',
        'icon.disabled': '#25252666',
        'icon.error': '#BE171B',
        'icon.info': '#2C6CBF',
        'icon.interactive': '#1EB8A6',
        'icon.inverse.disabled': '#FEFEFD99',
        'icon.inverse.interactive': '#88DDCC',
        'icon.inverse.primary': '#FFFFFF',
        'icon.inverse.secondary': '#FEFEFD',
        'icon.primary': '#161616',
        'icon.secondary': '#676666',
        'icon.secondary-1.default': '#CDF496',
        'icon.secondary-1.strong': '#325017',
        'icon.secondary-1.subtle': '#F6FDE8',
        'icon.secondary-2.default': '#EDD441',
        'icon.secondary-2.strong': '#6A4019',
        'icon.secondary-2.subtle': '#FCFBEA',
        'icon.secondary-3.default': '#FFAD54',
        'icon.secondary-3.strong': '#7E3410',
        'icon.secondary-3.subtle': '#FFF8ED',
        'icon.secondary-4.default': '#FFA9AB',
        'icon.secondary-4.strong': '#3E2D30',
        'icon.secondary-4.subtle': '#FFF7F7',
        'icon.secondary-5.default': '#A0A7FF',
        'icon.secondary-5.strong': '#2B2C41',
        'icon.secondary-5.subtle': '#F6F7FF',
        'icon.success': '#5B9D13',
        'icon.tertiary': '#C1C0BC',
        'icon.warning': '#BB8713',
        page: '#FEFEFD',
        'shadow.inner': '#FEFEFD66',
        'shadow.strong': '#25252629',
        'shadow.subtle': '#25252614',
        'state-layer.hover': '#25252614',
        'state-layer.hover-alt': '#25252614',
        'state-layer.hover-brand': '#B8ECE033',
        'state-layer.hover-on-color': '#25252633',
        'state-layer.inverse.hover': '#FEFEFD14',
        'state-layer.inverse.hover-brand': '#B8ECE033',
        'state-layer.inverse.hover-on-color': '#FEFEFD33',
        'state-layer.inverse.press': '#FEFEFD29',
        'state-layer.inverse.press-brand': '#B8ECE066',
        'state-layer.inverse.press-on-color': '#25252666',
        'state-layer.press': '#25252629',
        'state-layer.press-alt': '#25252629',
        'state-layer.press-brand': '#B8ECE066',
        'state-layer.press-on-color': '#25252666',
        'surface.brand.bold': '#003133',
        'surface.brand.bold-alt': '#00393D',
        'surface.brand.default': '#1EB8A6',
        'surface.brand.secondary-1.default': '#CDF496',
        'surface.brand.secondary-1.strong': '#325017',
        'surface.brand.secondary-1.subtle': '#E8FACD',
        'surface.brand.secondary-2.default': '#EDD441',
        'surface.brand.secondary-2.strong': '#6A4019',
        'surface.brand.secondary-2.subtle': '#F9F6C8',
        'surface.brand.secondary-3.default': '#FFAD54',
        'surface.brand.secondary-3.strong': '#7E3410',
        'surface.brand.secondary-3.subtle': '#FFF0D4',
        'surface.brand.secondary-4.default': '#FFA9AB',
        'surface.brand.secondary-4.strong': '#3E2D30',
        'surface.brand.secondary-4.subtle': '#FFEEEE',
        'surface.brand.secondary-5.default': '#A0A7FF',
        'surface.brand.secondary-5.strong': '#2B2C41',
        'surface.brand.secondary-5.subtle': '#ECEDFF',
        'surface.brand.strong': '#005A5D',
        'surface.brand.strong-alt': '#005A5D',
        'surface.brand.subtle': '#EDF8F5',
        'surface.default': '#FFFFFF',
        'surface.disabled': '#2525261F',
        'surface.error.default': '#BE171B',
        'surface.error.subtle': '#FFE1E2',
        'surface.info.default': '#255594',
        'surface.info.subtle': '#D6E6FB',
        'surface.inverse.default': '#161616',
        'surface.inverse.disabled': '#FEFEFD33',
        'surface.inverse.primary-neutral': '#959492',
        'surface.inverse.secondary-neutral': '#C1C0BC',
        'surface.inverse.tertiary-neutral': '#EEECE7',
        'surface.overlay': '#25252666',
        'surface.primary': '#EDF8F5',
        'surface.primary-alt': '#ECFFFE',
        'surface.primary-neutral': '#F8F7F5',
        'surface.secondary': '#D9F2EB',
        'surface.secondary-alt': '#BDFDFF',
        'surface.secondary-neutral': '#F5F4F1',
        'surface.selected': '#EDF8F5',
        'surface.strong-neutral': '#3B3A3C',
        'surface.success.default': '#457714',
        'surface.success.subtle': '#E8FACD',
        'surface.tertiary': '#B8ECE0',
        'surface.tertiary-alt': '#7BFBFF',
        'surface.tertiary-neutral': '#F1F0EC',
        'surface.warning.default': '#956213',
        'surface.warning.subtle': '#F9F6C8',
        'text.brand': '#005A5D',
        'text.brand-alt': '#B8ECE0',
        'text.disabled': '#25252666',
        'text.emphasized': '#08817D',
        'text.error': '#BE171B',
        'text.info': '#2C6CBF',
        'text.interactive': '#1EB8A6',
        'text.inverse.disabled': '#FEFEFD66',
        'text.inverse.interactive': '#88DDCC',
        'text.inverse.primary': '#FFFFFF',
        'text.inverse.secondary': '#FEFEFDCC',
        'text.placeholder': '#959492',
        'text.positive': '#457714',
        'text.primary': '#161616',
        'text.secondary': '#676666',
        'text.secondary-1.default': '#CDF496',
        'text.secondary-1.strong': '#325017',
        'text.secondary-1.subtle': '#F6FDE8',
        'text.secondary-2.default': '#EDD441',
        'text.secondary-2.strong': '#6A4019',
        'text.secondary-2.subtle': '#FCFBEA',
        'text.secondary-3.default': '#FFAD54',
        'text.secondary-3.strong': '#7E3410',
        'text.secondary-3.subtle': '#FFF8ED',
        'text.secondary-4.default': '#FFA9AB',
        'text.secondary-4.strong': '#3E2D30',
        'text.secondary-4.subtle': '#FFF7F7',
        'text.secondary-5.default': '#A0A7FF',
        'text.secondary-5.strong': '#2B2C41',
        'text.secondary-5.subtle': '#F6F7FF',
        'text.warning': '#BB8713',
        white: '#FFFFFF',
        'white-label.accent.icon.on-brand-accent': '#FFFFFF',
        'white-label.accent.surface': '#005A5D',
        'white-label.accent.text.on-brand-accent': '#FFFFFF',
        'white-label.footer.footer-bg': '#005A5D',
        'white-label.header.bg': '#FFFFFF',
        'white-label.header.on-header': '#161616',
        'white-label.headerSubtext': '#FFFFFF',
        'white-label.highlight': '#FFFFFF',
        'white-label.highlightText': '#FFFFFF',
        'white-label.notificationLogoBackground': '#FFFFFF',
        'white-label.publish-button.bg.header-bar': '#005A5D',
        'white-label.publish-button.bg.mobile-bottom-tab-bar': '#005A5D',
        'white-label.publish-button.icon.header-bar': '#FFFFFF',
        'white-label.publish-button.icon.mobile-bottom-tab-bar': '#FFFFFF',
        'white-label.publish-button.label.primary': '#FFFFFF',
        'white-label.splash': '#B8ECE0',
      },
      responsive: {
        'border-width.bold': '4',
        'border-width.emphasized': '2',
        'border-width.standard': '1.5',
        'border-width.subtle': '1',
        'radius.component.fields.input': '16',
        'radius.component.publish-button.button-radius': '1000',
        'radius.full': '1000',
        'radius.lg': '16',
        'radius.md': '12',
        'radius.none': '0',
        'radius.sm': '8',
        'radius.xl': '24',
        'radius.xs': '4',
        'radius.xxl': '32',
        'radius.xxs': '2',
        'sizing.body.max-width': '1279',
        'sizing.body.min-width': '768',
        'sizing.component.button.height.large': '56',
        'sizing.component.button.height.large-icn-button': '48',
        'sizing.component.button.height.medium': '40',
        'sizing.component.button.height.small': '32',
        'sizing.component.header.max-width': '1279',
        'sizing.component.header.min-width': '768',
        'sizing.general.0': '0',
        'sizing.general.x0,25': '1',
        'sizing.general.x0,5': '2',
        'sizing.general.x1': '4',
        'sizing.general.x10': '40',
        'sizing.general.x100': '400',
        'sizing.general.x12': '48',
        'sizing.general.x120': '480',
        'sizing.general.x14': '56',
        'sizing.general.x140': '560',
        'sizing.general.x150': '600',
        'sizing.general.x16': '64',
        'sizing.general.x160': '640',
        'sizing.general.x18': '72',
        'sizing.general.x180': '720',
        'sizing.general.x2': '8',
        'sizing.general.x20': '80',
        'sizing.general.x200': '800',
        'sizing.general.x22': '88',
        'sizing.general.x24': '96',
        'sizing.general.x3': '12',
        'sizing.general.x30': '120',
        'sizing.general.x36': '144',
        'sizing.general.x4': '16',
        'sizing.general.x40': '160',
        'sizing.general.x5': '20',
        'sizing.general.x50': '200',
        'sizing.general.x6': '24',
        'sizing.general.x60': '240',
        'sizing.general.x7': '28',
        'sizing.general.x70': '280',
        'sizing.general.x8': '32',
        'sizing.general.x80': '320',
        'sizing.general.x90': '360',
        'sizing.icon.default': '24',
        'sizing.icon.lg': '32',
        'sizing.icon.s': '16',
        'sizing.icon.sm': '20',
        'sizing.icon.xl': '48',
        'sizing.icon.xs': '12',
        'spacing.general.0': '0',
        'spacing.general.x0,5': '2',
        'spacing.general.x1': '4',
        'spacing.general.x10': '40',
        'spacing.general.x12': '48',
        'spacing.general.x14': '56',
        'spacing.general.x16': '64',
        'spacing.general.x18': '72',
        'spacing.general.x2': '8',
        'spacing.general.x20': '80',
        'spacing.general.x22': '88',
        'spacing.general.x24': '96',
        'spacing.general.x3': '12',
        'spacing.general.x30': '120',
        'spacing.general.x36': '144',
        'spacing.general.x4': '16',
        'spacing.general.x5': '20',
        'spacing.general.x6': '24',
        'spacing.general.x7': '28',
        'spacing.general.x8': '32',
        'spacing.semantic.line-height-fix': '2',
        'spacing.semantic.page-margin': '32',
        'typography.font-size.body.base': '16',
        'typography.font-size.body.caption': '10',
        'typography.font-size.body.large': '18',
        'typography.font-size.body.small': '14',
        'typography.font-size.body.x-large': '20',
        'typography.font-size.body.x-small': '12',
        'typography.font-size.header.display 1': '48',
        'typography.font-size.header.display 2': '56',
        'typography.font-size.header.large': '40',
        'typography.font-size.header.medium': '32',
        'typography.font-size.header.small': '28',
        'typography.font-size.header.x-small': '24',
        'typography.font-size.link.link-base': '16',
        'typography.font-size.link.link-large': '20',
        'typography.font-size.link.link-small': '14',
        'typography.letter-spacing.body.base': '0',
        'typography.letter-spacing.body.caption': '0',
        'typography.letter-spacing.body.large': '0',
        'typography.letter-spacing.body.small': '0',
        'typography.letter-spacing.body.x-large': '0',
        'typography.letter-spacing.body.x-small': '0',
        'typography.letter-spacing.header.display 1': '0',
        'typography.letter-spacing.header.display 2': '0',
        'typography.letter-spacing.header.large': '0',
        'typography.letter-spacing.header.medium': '0',
        'typography.letter-spacing.header.small': '0',
        'typography.letter-spacing.header.x-small': '0',
      },
      styles: {
        header: {
          'display-2': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '900',
              fontSize: '56',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'display-1': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '900',
              fontSize: '48',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          large: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '40',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '40', letterSpacing: '0', lineHeight: 'normal' },
          },
          medium: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '32',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'medium-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '32', letterSpacing: '0', lineHeight: 'normal' },
          },
          small: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '28',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'small-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '28', letterSpacing: '0', lineHeight: 'normal' },
          },
          'x-small': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '24',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '24', letterSpacing: '0', lineHeight: 'normal' },
          },
        },
        body: {
          'x-large': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-large-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          large: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          base: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          small: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'small-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
        },
        caption: {
          caption: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '10',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'caption-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '10',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'caption-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '10',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
        },
        link: {
          'link-large': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-base': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-small': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
        },
      },
    },
    large: {
      brand: 'default',
      mode: 'light',
      breakpoint: 'large',
      colors: {
        black: '#161616',
        'border.brand': '#005A5D',
        'border.brand-alt': '#B8ECE0',
        'border.disabled': '#25252614',
        'border.divider': '#2525261F',
        'border.error': '#BE171B',
        'border.focused': '#88DDCC',
        'border.info': '#2C6CBF',
        'border.interactive': '#1EB8A6',
        'border.inverse.disabled': '#FEFEFD66',
        'border.inverse.divider': '#FEFEFD33',
        'border.inverse.interactive': '#88DDCC',
        'border.inverse.primary': '#FFFFFF',
        'border.inverse.secondary': '#FEFEFD66',
        'border.inverse.selected': '#88DDCC',
        'border.inverse.strong': '#FFFFFF',
        'border.primary': '#25252666',
        'border.secondary': '#25252629',
        'border.secondary-1.default': '#CDF496',
        'border.secondary-1.strong': '#325017',
        'border.secondary-1.subtle': '#F6FDE8',
        'border.secondary-2.default': '#EDD441',
        'border.secondary-2.strong': '#6A4019',
        'border.secondary-2.subtle': '#FCFBEA',
        'border.secondary-3.default': '#FFAD54',
        'border.secondary-3.strong': '#7E3410',
        'border.secondary-3.subtle': '#FFF8ED',
        'border.secondary-4.default': '#FFA9AB',
        'border.secondary-4.strong': '#3E2D30',
        'border.secondary-4.subtle': '#FFF7F7',
        'border.secondary-5.default': '#A0A7FF',
        'border.secondary-5.strong': '#2B2C41',
        'border.secondary-5.subtle': '#F6F7FF',
        'border.selected': '#1EB8A6',
        'border.strong': '#161616',
        'border.success': '#5B9D13',
        'border.warning': '#BB8713',
        'component.button.bg.hover': '#FEFEFD33',
        'component.button.bg.inverted': '#FFFFFF',
        'component.button.bg.pressed': '#25252666',
        'component.button.bg.primary': '#005A5D',
        'component.button.bg.secondary': '#B8ECE0',
        'component.button.bg.tertiary': '#F5F4F1',
        'component.button.bg.transparent': '#25252699',
        'component.button.border.tertiary': '#25252629',
        'component.button.icon.tertiary': '#005A5D',
        'component.button.label.tertiary': '#005A5D',
        'gradient.Bottom Tab Bar - End': '#FEFEFDB2',
        'gradient.Bottom Tab Bar - Start': '#FEFEFD00',
        'gradient.primary': '#FFFFFF00',
        'icon.brand': '#005A5D',
        'icon.brand-alt': '#B8ECE0',
        'icon.disabled': '#25252666',
        'icon.error': '#BE171B',
        'icon.info': '#2C6CBF',
        'icon.interactive': '#1EB8A6',
        'icon.inverse.disabled': '#FEFEFD99',
        'icon.inverse.interactive': '#88DDCC',
        'icon.inverse.primary': '#FFFFFF',
        'icon.inverse.secondary': '#FEFEFD',
        'icon.primary': '#161616',
        'icon.secondary': '#676666',
        'icon.secondary-1.default': '#CDF496',
        'icon.secondary-1.strong': '#325017',
        'icon.secondary-1.subtle': '#F6FDE8',
        'icon.secondary-2.default': '#EDD441',
        'icon.secondary-2.strong': '#6A4019',
        'icon.secondary-2.subtle': '#FCFBEA',
        'icon.secondary-3.default': '#FFAD54',
        'icon.secondary-3.strong': '#7E3410',
        'icon.secondary-3.subtle': '#FFF8ED',
        'icon.secondary-4.default': '#FFA9AB',
        'icon.secondary-4.strong': '#3E2D30',
        'icon.secondary-4.subtle': '#FFF7F7',
        'icon.secondary-5.default': '#A0A7FF',
        'icon.secondary-5.strong': '#2B2C41',
        'icon.secondary-5.subtle': '#F6F7FF',
        'icon.success': '#5B9D13',
        'icon.tertiary': '#C1C0BC',
        'icon.warning': '#BB8713',
        page: '#FEFEFD',
        'shadow.inner': '#FEFEFD66',
        'shadow.strong': '#25252629',
        'shadow.subtle': '#25252614',
        'state-layer.hover': '#25252614',
        'state-layer.hover-alt': '#25252614',
        'state-layer.hover-brand': '#B8ECE033',
        'state-layer.hover-on-color': '#25252633',
        'state-layer.inverse.hover': '#FEFEFD14',
        'state-layer.inverse.hover-brand': '#B8ECE033',
        'state-layer.inverse.hover-on-color': '#FEFEFD33',
        'state-layer.inverse.press': '#FEFEFD29',
        'state-layer.inverse.press-brand': '#B8ECE066',
        'state-layer.inverse.press-on-color': '#25252666',
        'state-layer.press': '#25252629',
        'state-layer.press-alt': '#25252629',
        'state-layer.press-brand': '#B8ECE066',
        'state-layer.press-on-color': '#25252666',
        'surface.brand.bold': '#003133',
        'surface.brand.bold-alt': '#00393D',
        'surface.brand.default': '#1EB8A6',
        'surface.brand.secondary-1.default': '#CDF496',
        'surface.brand.secondary-1.strong': '#325017',
        'surface.brand.secondary-1.subtle': '#E8FACD',
        'surface.brand.secondary-2.default': '#EDD441',
        'surface.brand.secondary-2.strong': '#6A4019',
        'surface.brand.secondary-2.subtle': '#F9F6C8',
        'surface.brand.secondary-3.default': '#FFAD54',
        'surface.brand.secondary-3.strong': '#7E3410',
        'surface.brand.secondary-3.subtle': '#FFF0D4',
        'surface.brand.secondary-4.default': '#FFA9AB',
        'surface.brand.secondary-4.strong': '#3E2D30',
        'surface.brand.secondary-4.subtle': '#FFEEEE',
        'surface.brand.secondary-5.default': '#A0A7FF',
        'surface.brand.secondary-5.strong': '#2B2C41',
        'surface.brand.secondary-5.subtle': '#ECEDFF',
        'surface.brand.strong': '#005A5D',
        'surface.brand.strong-alt': '#005A5D',
        'surface.brand.subtle': '#EDF8F5',
        'surface.default': '#FFFFFF',
        'surface.disabled': '#2525261F',
        'surface.error.default': '#BE171B',
        'surface.error.subtle': '#FFE1E2',
        'surface.info.default': '#255594',
        'surface.info.subtle': '#D6E6FB',
        'surface.inverse.default': '#161616',
        'surface.inverse.disabled': '#FEFEFD33',
        'surface.inverse.primary-neutral': '#959492',
        'surface.inverse.secondary-neutral': '#C1C0BC',
        'surface.inverse.tertiary-neutral': '#EEECE7',
        'surface.overlay': '#25252666',
        'surface.primary': '#EDF8F5',
        'surface.primary-alt': '#ECFFFE',
        'surface.primary-neutral': '#F8F7F5',
        'surface.secondary': '#D9F2EB',
        'surface.secondary-alt': '#BDFDFF',
        'surface.secondary-neutral': '#F5F4F1',
        'surface.selected': '#EDF8F5',
        'surface.strong-neutral': '#3B3A3C',
        'surface.success.default': '#457714',
        'surface.success.subtle': '#E8FACD',
        'surface.tertiary': '#B8ECE0',
        'surface.tertiary-alt': '#7BFBFF',
        'surface.tertiary-neutral': '#F1F0EC',
        'surface.warning.default': '#956213',
        'surface.warning.subtle': '#F9F6C8',
        'text.brand': '#005A5D',
        'text.brand-alt': '#B8ECE0',
        'text.disabled': '#25252666',
        'text.emphasized': '#08817D',
        'text.error': '#BE171B',
        'text.info': '#2C6CBF',
        'text.interactive': '#1EB8A6',
        'text.inverse.disabled': '#FEFEFD66',
        'text.inverse.interactive': '#88DDCC',
        'text.inverse.primary': '#FFFFFF',
        'text.inverse.secondary': '#FEFEFDCC',
        'text.placeholder': '#959492',
        'text.positive': '#457714',
        'text.primary': '#161616',
        'text.secondary': '#676666',
        'text.secondary-1.default': '#CDF496',
        'text.secondary-1.strong': '#325017',
        'text.secondary-1.subtle': '#F6FDE8',
        'text.secondary-2.default': '#EDD441',
        'text.secondary-2.strong': '#6A4019',
        'text.secondary-2.subtle': '#FCFBEA',
        'text.secondary-3.default': '#FFAD54',
        'text.secondary-3.strong': '#7E3410',
        'text.secondary-3.subtle': '#FFF8ED',
        'text.secondary-4.default': '#FFA9AB',
        'text.secondary-4.strong': '#3E2D30',
        'text.secondary-4.subtle': '#FFF7F7',
        'text.secondary-5.default': '#A0A7FF',
        'text.secondary-5.strong': '#2B2C41',
        'text.secondary-5.subtle': '#F6F7FF',
        'text.warning': '#BB8713',
        white: '#FFFFFF',
        'white-label.accent.icon.on-brand-accent': '#FFFFFF',
        'white-label.accent.surface': '#005A5D',
        'white-label.accent.text.on-brand-accent': '#FFFFFF',
        'white-label.footer.footer-bg': '#005A5D',
        'white-label.header.bg': '#FFFFFF',
        'white-label.header.on-header': '#161616',
        'white-label.headerSubtext': '#FFFFFF',
        'white-label.highlight': '#FFFFFF',
        'white-label.highlightText': '#FFFFFF',
        'white-label.notificationLogoBackground': '#FFFFFF',
        'white-label.publish-button.bg.header-bar': '#005A5D',
        'white-label.publish-button.bg.mobile-bottom-tab-bar': '#005A5D',
        'white-label.publish-button.icon.header-bar': '#FFFFFF',
        'white-label.publish-button.icon.mobile-bottom-tab-bar': '#FFFFFF',
        'white-label.publish-button.label.primary': '#FFFFFF',
        'white-label.splash': '#B8ECE0',
      },
      responsive: {
        'border-width.bold': '4',
        'border-width.emphasized': '2',
        'border-width.standard': '1.5',
        'border-width.subtle': '1',
        'radius.component.fields.input': '16',
        'radius.component.publish-button.button-radius': '1000',
        'radius.full': '1000',
        'radius.lg': '16',
        'radius.md': '12',
        'radius.none': '0',
        'radius.sm': '8',
        'radius.xl': '24',
        'radius.xs': '4',
        'radius.xxl': '32',
        'radius.xxs': '2',
        'sizing.body.max-width': '1320',
        'sizing.body.min-width': '1280',
        'sizing.component.button.height.large': '56',
        'sizing.component.button.height.large-icn-button': '48',
        'sizing.component.button.height.medium': '40',
        'sizing.component.button.height.small': '32',
        'sizing.component.header.max-width': '1920',
        'sizing.component.header.min-width': '1280',
        'sizing.general.0': '0',
        'sizing.general.x0,25': '1',
        'sizing.general.x0,5': '2',
        'sizing.general.x1': '4',
        'sizing.general.x10': '40',
        'sizing.general.x100': '400',
        'sizing.general.x12': '48',
        'sizing.general.x120': '480',
        'sizing.general.x14': '56',
        'sizing.general.x140': '560',
        'sizing.general.x150': '600',
        'sizing.general.x16': '64',
        'sizing.general.x160': '640',
        'sizing.general.x18': '72',
        'sizing.general.x180': '720',
        'sizing.general.x2': '8',
        'sizing.general.x20': '80',
        'sizing.general.x200': '800',
        'sizing.general.x22': '88',
        'sizing.general.x24': '96',
        'sizing.general.x3': '12',
        'sizing.general.x30': '120',
        'sizing.general.x36': '144',
        'sizing.general.x4': '16',
        'sizing.general.x40': '160',
        'sizing.general.x5': '20',
        'sizing.general.x50': '200',
        'sizing.general.x6': '24',
        'sizing.general.x60': '240',
        'sizing.general.x7': '28',
        'sizing.general.x70': '280',
        'sizing.general.x8': '32',
        'sizing.general.x80': '320',
        'sizing.general.x90': '360',
        'sizing.icon.default': '24',
        'sizing.icon.lg': '32',
        'sizing.icon.s': '16',
        'sizing.icon.sm': '20',
        'sizing.icon.xl': '48',
        'sizing.icon.xs': '12',
        'spacing.general.0': '0',
        'spacing.general.x0,5': '2',
        'spacing.general.x1': '4',
        'spacing.general.x10': '40',
        'spacing.general.x12': '48',
        'spacing.general.x14': '56',
        'spacing.general.x16': '64',
        'spacing.general.x18': '72',
        'spacing.general.x2': '8',
        'spacing.general.x20': '80',
        'spacing.general.x22': '88',
        'spacing.general.x24': '96',
        'spacing.general.x3': '12',
        'spacing.general.x30': '120',
        'spacing.general.x36': '144',
        'spacing.general.x4': '16',
        'spacing.general.x5': '20',
        'spacing.general.x6': '24',
        'spacing.general.x7': '28',
        'spacing.general.x8': '32',
        'spacing.semantic.line-height-fix': '2',
        'spacing.semantic.page-margin': '48',
        'typography.font-size.body.base': '16',
        'typography.font-size.body.caption': '10',
        'typography.font-size.body.large': '18',
        'typography.font-size.body.small': '14',
        'typography.font-size.body.x-large': '20',
        'typography.font-size.body.x-small': '12',
        'typography.font-size.header.display 1': '56',
        'typography.font-size.header.display 2': '64',
        'typography.font-size.header.large': '48',
        'typography.font-size.header.medium': '40',
        'typography.font-size.header.small': '36',
        'typography.font-size.header.x-small': '32',
        'typography.font-size.link.link-base': '16',
        'typography.font-size.link.link-large': '20',
        'typography.font-size.link.link-small': '14',
        'typography.letter-spacing.body.base': '0',
        'typography.letter-spacing.body.caption': '0',
        'typography.letter-spacing.body.large': '0',
        'typography.letter-spacing.body.small': '0',
        'typography.letter-spacing.body.x-large': '0',
        'typography.letter-spacing.body.x-small': '0',
        'typography.letter-spacing.header.display 1': '0',
        'typography.letter-spacing.header.display 2': '0',
        'typography.letter-spacing.header.large': '0',
        'typography.letter-spacing.header.medium': '0',
        'typography.letter-spacing.header.small': '0',
        'typography.letter-spacing.header.x-small': '0',
      },
      styles: {
        header: {
          'display-2': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '900',
              fontSize: '64',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'display-1': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '900',
              fontSize: '56',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          large: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '48',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '48', letterSpacing: '0', lineHeight: 'normal' },
          },
          medium: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '40',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'medium-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '40', letterSpacing: '0', lineHeight: 'normal' },
          },
          small: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '36',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'small-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '36', letterSpacing: '0', lineHeight: 'normal' },
          },
          'x-small': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '32',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '32', letterSpacing: '0', lineHeight: 'normal' },
          },
        },
        body: {
          'x-large': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-large-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          large: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          base: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          small: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'small-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
        },
        caption: {
          caption: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '10',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'caption-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '10',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'caption-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '10',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
        },
        link: {
          'link-large': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-base': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-small': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
        },
      },
    },
  },
  dark: {
    small: {
      brand: 'default',
      mode: 'dark',
      breakpoint: 'small',
      colors: {
        black: '#161616',
        'border.brand': '#B8ECE0',
        'border.brand-alt': '#005A5D',
        'border.disabled': '#25252629',
        'border.divider': '#FEFEFD33',
        'border.error': '#FD6C6F',
        'border.focused': '#B8ECE0',
        'border.info': '#5C9CEF',
        'border.interactive': '#45D3BC',
        'border.inverse.disabled': '#25252666',
        'border.inverse.divider': '#2525261F',
        'border.inverse.interactive': '#1EB8A6',
        'border.inverse.primary': '#25252666',
        'border.inverse.secondary': '#25252629',
        'border.inverse.selected': '#08817D',
        'border.inverse.strong': '#161616',
        'border.primary': '#FEFEFD66',
        'border.secondary': '#FEFEFD29',
        'border.secondary-1.default': '#96DF3C',
        'border.secondary-1.strong': '#F6FDE8',
        'border.secondary-1.subtle': '#457714',
        'border.secondary-2.default': '#E8C427',
        'border.secondary-2.strong': '#FCFBEA',
        'border.secondary-2.subtle': '#956213',
        'border.secondary-3.default': '#FFAD54',
        'border.secondary-3.strong': '#FFF8ED',
        'border.secondary-3.subtle': '#C64C08',
        'border.secondary-4.default': '#FFBABC',
        'border.secondary-4.strong': '#FFF7F7',
        'border.secondary-4.subtle': '#9F6B6E',
        'border.secondary-5.default': '#B3B8FF',
        'border.secondary-5.strong': '#F6F7FF',
        'border.secondary-5.subtle': '#666AA0',
        'border.selected': '#009597',
        'border.strong': '#FFFFFF',
        'border.success': '#96DF3C',
        'border.warning': '#E8C427',
        'component.button.bg.hover': '#FEFEFD33',
        'component.button.bg.inverted': '#161616',
        'component.button.bg.pressed': '#25252666',
        'component.button.bg.primary': '#036D6D',
        'component.button.bg.secondary': '#B8ECE0',
        'component.button.bg.tertiary': '#3B3A3C',
        'component.button.bg.transparent': '#FEFEFD66',
        'component.button.border.tertiary': '#FFFFFF',
        'component.button.icon.tertiary': '#B8ECE0',
        'component.button.label.tertiary': '#B8ECE0',
        'gradient.Bottom Tab Bar - End': '#161616E5',
        'gradient.Bottom Tab Bar - Start': '#16161600',
        'gradient.primary': '#16161600',
        'icon.brand': '#B8ECE0',
        'icon.brand-alt': '#005A5D',
        'icon.disabled': '#FEFEFD66',
        'icon.error': '#FD6C6F',
        'icon.info': '#85B5F3',
        'icon.interactive': '#45D3BC',
        'icon.inverse.disabled': '#25252666',
        'icon.inverse.interactive': '#1EB8A6',
        'icon.inverse.primary': '#161616',
        'icon.inverse.secondary': '#676666',
        'icon.primary': '#FFFFFF',
        'icon.secondary': '#C1C0BC',
        'icon.secondary-1.default': '#96DF3C',
        'icon.secondary-1.strong': '#F6FDE8',
        'icon.secondary-1.subtle': '#325017',
        'icon.secondary-2.default': '#E8C427',
        'icon.secondary-2.strong': '#FCFBEA',
        'icon.secondary-2.subtle': '#6A4019',
        'icon.secondary-3.default': '#FFAD54',
        'icon.secondary-3.strong': '#FFF8ED',
        'icon.secondary-3.subtle': '#7E3410',
        'icon.secondary-4.default': '#FFBABC',
        'icon.secondary-4.strong': '#FFF7F7',
        'icon.secondary-4.subtle': '#3E2D30',
        'icon.secondary-5.default': '#B3B8FF',
        'icon.secondary-5.strong': '#F6F7FF',
        'icon.secondary-5.subtle': '#2B2C41',
        'icon.success': '#96DF3C',
        'icon.tertiary': '#676666',
        'icon.warning': '#EDD441',
        page: '#161616',
        'shadow.inner': '#FEFEFD33',
        'shadow.strong': '#25252629',
        'shadow.subtle': '#25252614',
        'state-layer.hover': '#FEFEFD14',
        'state-layer.hover-alt': '#25252629',
        'state-layer.hover-brand': '#B8ECE029',
        'state-layer.hover-on-color': '#FEFEFD33',
        'state-layer.inverse.hover': '#25252614',
        'state-layer.inverse.hover-brand': '#B8ECE033',
        'state-layer.inverse.hover-on-color': '#FEFEFD33',
        'state-layer.inverse.press': '#25252629',
        'state-layer.inverse.press-brand': '#B8ECE066',
        'state-layer.inverse.press-on-color': '#25252666',
        'state-layer.press': '#FEFEFD29',
        'state-layer.press-alt': '#25252666',
        'state-layer.press-brand': '#B8ECE066',
        'state-layer.press-on-color': '#FEFEFD66',
        'surface.brand.bold': '#D9F2EB',
        'surface.brand.bold-alt': '#BDFDFF',
        'surface.brand.default': '#45D3BC',
        'surface.brand.secondary-1.default': '#96DF3C',
        'surface.brand.secondary-1.strong': '#F6FDE8',
        'surface.brand.secondary-1.subtle': '#325017',
        'surface.brand.secondary-2.default': '#E8C427',
        'surface.brand.secondary-2.strong': '#FCFBEA',
        'surface.brand.secondary-2.subtle': '#6A4019',
        'surface.brand.secondary-3.default': '#FFAD54',
        'surface.brand.secondary-3.strong': '#FFF8ED',
        'surface.brand.secondary-3.subtle': '#7E3410',
        'surface.brand.secondary-4.default': '#FFBABC',
        'surface.brand.secondary-4.strong': '#FFF7F7',
        'surface.brand.secondary-4.subtle': '#3E2D30',
        'surface.brand.secondary-5.default': '#B3B8FF',
        'surface.brand.secondary-5.strong': '#F6F7FF',
        'surface.brand.secondary-5.subtle': '#2B2C41',
        'surface.brand.strong': '#D9F2EB',
        'surface.brand.strong-alt': '#ECFFFE',
        'surface.brand.subtle': '#08817D',
        'surface.default': '#252526',
        'surface.disabled': '#FEFEFD33',
        'surface.error.default': '#FD6C6F',
        'surface.error.subtle': '#F53E4233',
        'surface.info.default': '#5C9CEF',
        'surface.info.subtle': '#3383EB33',
        'surface.inverse.default': '#FFFFFF',
        'surface.inverse.disabled': '#25252633',
        'surface.inverse.primary-neutral': '#959492',
        'surface.inverse.secondary-neutral': '#676666',
        'surface.inverse.tertiary-neutral': '#3B3A3C',
        'surface.overlay': '#25252666',
        'surface.primary': '#003133',
        'surface.primary-alt': '#00393D',
        'surface.primary-neutral': '#252526',
        'surface.secondary': '#005A5D',
        'surface.secondary-alt': '#005A5D',
        'surface.secondary-neutral': '#3B3A3C',
        'surface.selected': '#003133',
        'surface.strong-neutral': '#EEECE7',
        'surface.success.default': '#77C41E',
        'surface.success.subtle': '#77C41E33',
        'surface.tertiary': '#036D6D',
        'surface.tertiary-alt': '#007377',
        'surface.tertiary-neutral': '#676666',
        'surface.warning.default': '#E8C427',
        'surface.warning.subtle': '#D8AD1A33',
        'text.brand': '#B8ECE0',
        'text.brand-alt': '#005A5D',
        'text.disabled': '#FEFEFD66',
        'text.emphasized': '#45D3BC',
        'text.error': '#FD6C6F',
        'text.info': '#85B5F3',
        'text.interactive': '#45D3BC',
        'text.inverse.disabled': '#25252666',
        'text.inverse.interactive': '#1EB8A6',
        'text.inverse.primary': '#252526',
        'text.inverse.secondary': '#676666',
        'text.placeholder': '#959492',
        'text.positive': '#96DF3C',
        'text.primary': '#FFFFFF',
        'text.secondary': '#C1C0BC',
        'text.secondary-1.default': '#96DF3C',
        'text.secondary-1.strong': '#F6FDE8',
        'text.secondary-1.subtle': '#325017',
        'text.secondary-2.default': '#E8C427',
        'text.secondary-2.strong': '#FCFBEA',
        'text.secondary-2.subtle': '#6A4019',
        'text.secondary-3.default': '#FFAD54',
        'text.secondary-3.strong': '#FFF8ED',
        'text.secondary-3.subtle': '#7E3410',
        'text.secondary-4.default': '#FFBABC',
        'text.secondary-4.strong': '#FFF7F7',
        'text.secondary-4.subtle': '#3E2D30',
        'text.secondary-5.default': '#B3B8FF',
        'text.secondary-5.strong': '#F6F7FF',
        'text.secondary-5.subtle': '#2B2C41',
        'text.warning': '#EDD441',
        white: '#FFFFFF',
        'white-label.accent.icon.on-brand-accent': '#FFFFFF',
        'white-label.accent.surface': '#005A5D',
        'white-label.accent.text.on-brand-accent': '#FFFFFF',
        'white-label.footer.footer-bg': '#161616',
        'white-label.header.bg': '#161616',
        'white-label.header.on-header': '#FFFFFF',
        'white-label.headerSubtext': '#FFFFFF',
        'white-label.highlight': '#FFFFFF',
        'white-label.highlightText': '#FFFFFF',
        'white-label.notificationLogoBackground': '#FFFFFF',
        'white-label.publish-button.bg.header-bar': '#005A5D',
        'white-label.publish-button.bg.mobile-bottom-tab-bar': '#005A5D',
        'white-label.publish-button.icon.header-bar': '#FFFFFF',
        'white-label.publish-button.icon.mobile-bottom-tab-bar': '#FFFFFF',
        'white-label.publish-button.label.primary': '#FFFFFF',
        'white-label.splash': '#B8ECE0',
      },
      responsive: {
        'border-width.bold': '4',
        'border-width.emphasized': '2',
        'border-width.standard': '1.5',
        'border-width.subtle': '1',
        'radius.component.fields.input': '16',
        'radius.component.publish-button.button-radius': '1000',
        'radius.full': '1000',
        'radius.lg': '16',
        'radius.md': '12',
        'radius.none': '0',
        'radius.sm': '8',
        'radius.xl': '24',
        'radius.xs': '4',
        'radius.xxl': '32',
        'radius.xxs': '2',
        'sizing.body.max-width': '767',
        'sizing.body.min-width': '320',
        'sizing.component.button.height.large': '56',
        'sizing.component.button.height.large-icn-button': '48',
        'sizing.component.button.height.medium': '40',
        'sizing.component.button.height.small': '32',
        'sizing.component.header.max-width': '767',
        'sizing.component.header.min-width': '320',
        'sizing.general.0': '0',
        'sizing.general.x0,25': '1',
        'sizing.general.x0,5': '2',
        'sizing.general.x1': '4',
        'sizing.general.x10': '40',
        'sizing.general.x100': '400',
        'sizing.general.x12': '48',
        'sizing.general.x120': '480',
        'sizing.general.x14': '56',
        'sizing.general.x140': '560',
        'sizing.general.x150': '600',
        'sizing.general.x16': '64',
        'sizing.general.x160': '640',
        'sizing.general.x18': '72',
        'sizing.general.x180': '720',
        'sizing.general.x2': '8',
        'sizing.general.x20': '80',
        'sizing.general.x200': '800',
        'sizing.general.x22': '88',
        'sizing.general.x24': '96',
        'sizing.general.x3': '12',
        'sizing.general.x30': '120',
        'sizing.general.x36': '144',
        'sizing.general.x4': '16',
        'sizing.general.x40': '160',
        'sizing.general.x5': '20',
        'sizing.general.x50': '200',
        'sizing.general.x6': '24',
        'sizing.general.x60': '240',
        'sizing.general.x7': '28',
        'sizing.general.x70': '280',
        'sizing.general.x8': '32',
        'sizing.general.x80': '320',
        'sizing.general.x90': '360',
        'sizing.icon.default': '24',
        'sizing.icon.lg': '32',
        'sizing.icon.s': '16',
        'sizing.icon.sm': '20',
        'sizing.icon.xl': '48',
        'sizing.icon.xs': '12',
        'spacing.general.0': '0',
        'spacing.general.x0,5': '2',
        'spacing.general.x1': '4',
        'spacing.general.x10': '40',
        'spacing.general.x12': '48',
        'spacing.general.x14': '56',
        'spacing.general.x16': '64',
        'spacing.general.x18': '72',
        'spacing.general.x2': '8',
        'spacing.general.x20': '80',
        'spacing.general.x22': '88',
        'spacing.general.x24': '96',
        'spacing.general.x3': '12',
        'spacing.general.x30': '120',
        'spacing.general.x36': '144',
        'spacing.general.x4': '16',
        'spacing.general.x5': '20',
        'spacing.general.x6': '24',
        'spacing.general.x7': '28',
        'spacing.general.x8': '32',
        'spacing.semantic.line-height-fix': '2',
        'spacing.semantic.page-margin': '16',
        'typography.font-size.body.base': '16',
        'typography.font-size.body.caption': '10',
        'typography.font-size.body.large': '18',
        'typography.font-size.body.small': '14',
        'typography.font-size.body.x-large': '20',
        'typography.font-size.body.x-small': '12',
        'typography.font-size.header.display 1': '48',
        'typography.font-size.header.display 2': '56',
        'typography.font-size.header.large': '40',
        'typography.font-size.header.medium': '28',
        'typography.font-size.header.small': '24',
        'typography.font-size.header.x-small': '20',
        'typography.font-size.link.link-base': '16',
        'typography.font-size.link.link-large': '20',
        'typography.font-size.link.link-small': '14',
        'typography.letter-spacing.body.base': '0',
        'typography.letter-spacing.body.caption': '0',
        'typography.letter-spacing.body.large': '0',
        'typography.letter-spacing.body.small': '0',
        'typography.letter-spacing.body.x-large': '0',
        'typography.letter-spacing.body.x-small': '0',
        'typography.letter-spacing.header.display 1': '0',
        'typography.letter-spacing.header.display 2': '0',
        'typography.letter-spacing.header.large': '0',
        'typography.letter-spacing.header.medium': '0',
        'typography.letter-spacing.header.small': '0',
        'typography.letter-spacing.header.x-small': '0',
      },
      styles: {
        header: {
          'display-2': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '900',
              fontSize: '56',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'display-1': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '900',
              fontSize: '48',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          large: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '40',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '40', letterSpacing: '0', lineHeight: 'normal' },
          },
          medium: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '28',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'medium-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '28', letterSpacing: '0', lineHeight: 'normal' },
          },
          small: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '24',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'small-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '24', letterSpacing: '0', lineHeight: 'normal' },
          },
          'x-small': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '20', letterSpacing: '0', lineHeight: 'normal' },
          },
        },
        body: {
          'x-large': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-large-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          large: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          base: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          small: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'small-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
        },
        caption: {
          caption: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '10',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'caption-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '10',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'caption-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '10',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
        },
        link: {
          'link-large': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-base': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-small': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
        },
      },
    },
    medium: {
      brand: 'default',
      mode: 'dark',
      breakpoint: 'medium',
      colors: {
        black: '#161616',
        'border.brand': '#B8ECE0',
        'border.brand-alt': '#005A5D',
        'border.disabled': '#25252629',
        'border.divider': '#FEFEFD33',
        'border.error': '#FD6C6F',
        'border.focused': '#B8ECE0',
        'border.info': '#5C9CEF',
        'border.interactive': '#45D3BC',
        'border.inverse.disabled': '#25252666',
        'border.inverse.divider': '#2525261F',
        'border.inverse.interactive': '#1EB8A6',
        'border.inverse.primary': '#25252666',
        'border.inverse.secondary': '#25252629',
        'border.inverse.selected': '#08817D',
        'border.inverse.strong': '#161616',
        'border.primary': '#FEFEFD66',
        'border.secondary': '#FEFEFD29',
        'border.secondary-1.default': '#96DF3C',
        'border.secondary-1.strong': '#F6FDE8',
        'border.secondary-1.subtle': '#457714',
        'border.secondary-2.default': '#E8C427',
        'border.secondary-2.strong': '#FCFBEA',
        'border.secondary-2.subtle': '#956213',
        'border.secondary-3.default': '#FFAD54',
        'border.secondary-3.strong': '#FFF8ED',
        'border.secondary-3.subtle': '#C64C08',
        'border.secondary-4.default': '#FFBABC',
        'border.secondary-4.strong': '#FFF7F7',
        'border.secondary-4.subtle': '#9F6B6E',
        'border.secondary-5.default': '#B3B8FF',
        'border.secondary-5.strong': '#F6F7FF',
        'border.secondary-5.subtle': '#666AA0',
        'border.selected': '#009597',
        'border.strong': '#FFFFFF',
        'border.success': '#96DF3C',
        'border.warning': '#E8C427',
        'component.button.bg.hover': '#FEFEFD33',
        'component.button.bg.inverted': '#161616',
        'component.button.bg.pressed': '#25252666',
        'component.button.bg.primary': '#036D6D',
        'component.button.bg.secondary': '#B8ECE0',
        'component.button.bg.tertiary': '#3B3A3C',
        'component.button.bg.transparent': '#FEFEFD66',
        'component.button.border.tertiary': '#FFFFFF',
        'component.button.icon.tertiary': '#B8ECE0',
        'component.button.label.tertiary': '#B8ECE0',
        'gradient.Bottom Tab Bar - End': '#161616E5',
        'gradient.Bottom Tab Bar - Start': '#16161600',
        'gradient.primary': '#16161600',
        'icon.brand': '#B8ECE0',
        'icon.brand-alt': '#005A5D',
        'icon.disabled': '#FEFEFD66',
        'icon.error': '#FD6C6F',
        'icon.info': '#85B5F3',
        'icon.interactive': '#45D3BC',
        'icon.inverse.disabled': '#25252666',
        'icon.inverse.interactive': '#1EB8A6',
        'icon.inverse.primary': '#161616',
        'icon.inverse.secondary': '#676666',
        'icon.primary': '#FFFFFF',
        'icon.secondary': '#C1C0BC',
        'icon.secondary-1.default': '#96DF3C',
        'icon.secondary-1.strong': '#F6FDE8',
        'icon.secondary-1.subtle': '#325017',
        'icon.secondary-2.default': '#E8C427',
        'icon.secondary-2.strong': '#FCFBEA',
        'icon.secondary-2.subtle': '#6A4019',
        'icon.secondary-3.default': '#FFAD54',
        'icon.secondary-3.strong': '#FFF8ED',
        'icon.secondary-3.subtle': '#7E3410',
        'icon.secondary-4.default': '#FFBABC',
        'icon.secondary-4.strong': '#FFF7F7',
        'icon.secondary-4.subtle': '#3E2D30',
        'icon.secondary-5.default': '#B3B8FF',
        'icon.secondary-5.strong': '#F6F7FF',
        'icon.secondary-5.subtle': '#2B2C41',
        'icon.success': '#96DF3C',
        'icon.tertiary': '#676666',
        'icon.warning': '#EDD441',
        page: '#161616',
        'shadow.inner': '#FEFEFD33',
        'shadow.strong': '#25252629',
        'shadow.subtle': '#25252614',
        'state-layer.hover': '#FEFEFD14',
        'state-layer.hover-alt': '#25252629',
        'state-layer.hover-brand': '#B8ECE029',
        'state-layer.hover-on-color': '#FEFEFD33',
        'state-layer.inverse.hover': '#25252614',
        'state-layer.inverse.hover-brand': '#B8ECE033',
        'state-layer.inverse.hover-on-color': '#FEFEFD33',
        'state-layer.inverse.press': '#25252629',
        'state-layer.inverse.press-brand': '#B8ECE066',
        'state-layer.inverse.press-on-color': '#25252666',
        'state-layer.press': '#FEFEFD29',
        'state-layer.press-alt': '#25252666',
        'state-layer.press-brand': '#B8ECE066',
        'state-layer.press-on-color': '#FEFEFD66',
        'surface.brand.bold': '#D9F2EB',
        'surface.brand.bold-alt': '#BDFDFF',
        'surface.brand.default': '#45D3BC',
        'surface.brand.secondary-1.default': '#96DF3C',
        'surface.brand.secondary-1.strong': '#F6FDE8',
        'surface.brand.secondary-1.subtle': '#325017',
        'surface.brand.secondary-2.default': '#E8C427',
        'surface.brand.secondary-2.strong': '#FCFBEA',
        'surface.brand.secondary-2.subtle': '#6A4019',
        'surface.brand.secondary-3.default': '#FFAD54',
        'surface.brand.secondary-3.strong': '#FFF8ED',
        'surface.brand.secondary-3.subtle': '#7E3410',
        'surface.brand.secondary-4.default': '#FFBABC',
        'surface.brand.secondary-4.strong': '#FFF7F7',
        'surface.brand.secondary-4.subtle': '#3E2D30',
        'surface.brand.secondary-5.default': '#B3B8FF',
        'surface.brand.secondary-5.strong': '#F6F7FF',
        'surface.brand.secondary-5.subtle': '#2B2C41',
        'surface.brand.strong': '#D9F2EB',
        'surface.brand.strong-alt': '#ECFFFE',
        'surface.brand.subtle': '#08817D',
        'surface.default': '#252526',
        'surface.disabled': '#FEFEFD33',
        'surface.error.default': '#FD6C6F',
        'surface.error.subtle': '#F53E4233',
        'surface.info.default': '#5C9CEF',
        'surface.info.subtle': '#3383EB33',
        'surface.inverse.default': '#FFFFFF',
        'surface.inverse.disabled': '#25252633',
        'surface.inverse.primary-neutral': '#959492',
        'surface.inverse.secondary-neutral': '#676666',
        'surface.inverse.tertiary-neutral': '#3B3A3C',
        'surface.overlay': '#25252666',
        'surface.primary': '#003133',
        'surface.primary-alt': '#00393D',
        'surface.primary-neutral': '#252526',
        'surface.secondary': '#005A5D',
        'surface.secondary-alt': '#005A5D',
        'surface.secondary-neutral': '#3B3A3C',
        'surface.selected': '#003133',
        'surface.strong-neutral': '#EEECE7',
        'surface.success.default': '#77C41E',
        'surface.success.subtle': '#77C41E33',
        'surface.tertiary': '#036D6D',
        'surface.tertiary-alt': '#007377',
        'surface.tertiary-neutral': '#676666',
        'surface.warning.default': '#E8C427',
        'surface.warning.subtle': '#D8AD1A33',
        'text.brand': '#B8ECE0',
        'text.brand-alt': '#005A5D',
        'text.disabled': '#FEFEFD66',
        'text.emphasized': '#45D3BC',
        'text.error': '#FD6C6F',
        'text.info': '#85B5F3',
        'text.interactive': '#45D3BC',
        'text.inverse.disabled': '#25252666',
        'text.inverse.interactive': '#1EB8A6',
        'text.inverse.primary': '#252526',
        'text.inverse.secondary': '#676666',
        'text.placeholder': '#959492',
        'text.positive': '#96DF3C',
        'text.primary': '#FFFFFF',
        'text.secondary': '#C1C0BC',
        'text.secondary-1.default': '#96DF3C',
        'text.secondary-1.strong': '#F6FDE8',
        'text.secondary-1.subtle': '#325017',
        'text.secondary-2.default': '#E8C427',
        'text.secondary-2.strong': '#FCFBEA',
        'text.secondary-2.subtle': '#6A4019',
        'text.secondary-3.default': '#FFAD54',
        'text.secondary-3.strong': '#FFF8ED',
        'text.secondary-3.subtle': '#7E3410',
        'text.secondary-4.default': '#FFBABC',
        'text.secondary-4.strong': '#FFF7F7',
        'text.secondary-4.subtle': '#3E2D30',
        'text.secondary-5.default': '#B3B8FF',
        'text.secondary-5.strong': '#F6F7FF',
        'text.secondary-5.subtle': '#2B2C41',
        'text.warning': '#EDD441',
        white: '#FFFFFF',
        'white-label.accent.icon.on-brand-accent': '#FFFFFF',
        'white-label.accent.surface': '#005A5D',
        'white-label.accent.text.on-brand-accent': '#FFFFFF',
        'white-label.footer.footer-bg': '#161616',
        'white-label.header.bg': '#161616',
        'white-label.header.on-header': '#FFFFFF',
        'white-label.headerSubtext': '#FFFFFF',
        'white-label.highlight': '#FFFFFF',
        'white-label.highlightText': '#FFFFFF',
        'white-label.notificationLogoBackground': '#FFFFFF',
        'white-label.publish-button.bg.header-bar': '#005A5D',
        'white-label.publish-button.bg.mobile-bottom-tab-bar': '#005A5D',
        'white-label.publish-button.icon.header-bar': '#FFFFFF',
        'white-label.publish-button.icon.mobile-bottom-tab-bar': '#FFFFFF',
        'white-label.publish-button.label.primary': '#FFFFFF',
        'white-label.splash': '#B8ECE0',
      },
      responsive: {
        'border-width.bold': '4',
        'border-width.emphasized': '2',
        'border-width.standard': '1.5',
        'border-width.subtle': '1',
        'radius.component.fields.input': '16',
        'radius.component.publish-button.button-radius': '1000',
        'radius.full': '1000',
        'radius.lg': '16',
        'radius.md': '12',
        'radius.none': '0',
        'radius.sm': '8',
        'radius.xl': '24',
        'radius.xs': '4',
        'radius.xxl': '32',
        'radius.xxs': '2',
        'sizing.body.max-width': '1279',
        'sizing.body.min-width': '768',
        'sizing.component.button.height.large': '56',
        'sizing.component.button.height.large-icn-button': '48',
        'sizing.component.button.height.medium': '40',
        'sizing.component.button.height.small': '32',
        'sizing.component.header.max-width': '1279',
        'sizing.component.header.min-width': '768',
        'sizing.general.0': '0',
        'sizing.general.x0,25': '1',
        'sizing.general.x0,5': '2',
        'sizing.general.x1': '4',
        'sizing.general.x10': '40',
        'sizing.general.x100': '400',
        'sizing.general.x12': '48',
        'sizing.general.x120': '480',
        'sizing.general.x14': '56',
        'sizing.general.x140': '560',
        'sizing.general.x150': '600',
        'sizing.general.x16': '64',
        'sizing.general.x160': '640',
        'sizing.general.x18': '72',
        'sizing.general.x180': '720',
        'sizing.general.x2': '8',
        'sizing.general.x20': '80',
        'sizing.general.x200': '800',
        'sizing.general.x22': '88',
        'sizing.general.x24': '96',
        'sizing.general.x3': '12',
        'sizing.general.x30': '120',
        'sizing.general.x36': '144',
        'sizing.general.x4': '16',
        'sizing.general.x40': '160',
        'sizing.general.x5': '20',
        'sizing.general.x50': '200',
        'sizing.general.x6': '24',
        'sizing.general.x60': '240',
        'sizing.general.x7': '28',
        'sizing.general.x70': '280',
        'sizing.general.x8': '32',
        'sizing.general.x80': '320',
        'sizing.general.x90': '360',
        'sizing.icon.default': '24',
        'sizing.icon.lg': '32',
        'sizing.icon.s': '16',
        'sizing.icon.sm': '20',
        'sizing.icon.xl': '48',
        'sizing.icon.xs': '12',
        'spacing.general.0': '0',
        'spacing.general.x0,5': '2',
        'spacing.general.x1': '4',
        'spacing.general.x10': '40',
        'spacing.general.x12': '48',
        'spacing.general.x14': '56',
        'spacing.general.x16': '64',
        'spacing.general.x18': '72',
        'spacing.general.x2': '8',
        'spacing.general.x20': '80',
        'spacing.general.x22': '88',
        'spacing.general.x24': '96',
        'spacing.general.x3': '12',
        'spacing.general.x30': '120',
        'spacing.general.x36': '144',
        'spacing.general.x4': '16',
        'spacing.general.x5': '20',
        'spacing.general.x6': '24',
        'spacing.general.x7': '28',
        'spacing.general.x8': '32',
        'spacing.semantic.line-height-fix': '2',
        'spacing.semantic.page-margin': '32',
        'typography.font-size.body.base': '16',
        'typography.font-size.body.caption': '10',
        'typography.font-size.body.large': '18',
        'typography.font-size.body.small': '14',
        'typography.font-size.body.x-large': '20',
        'typography.font-size.body.x-small': '12',
        'typography.font-size.header.display 1': '48',
        'typography.font-size.header.display 2': '56',
        'typography.font-size.header.large': '40',
        'typography.font-size.header.medium': '32',
        'typography.font-size.header.small': '28',
        'typography.font-size.header.x-small': '24',
        'typography.font-size.link.link-base': '16',
        'typography.font-size.link.link-large': '20',
        'typography.font-size.link.link-small': '14',
        'typography.letter-spacing.body.base': '0',
        'typography.letter-spacing.body.caption': '0',
        'typography.letter-spacing.body.large': '0',
        'typography.letter-spacing.body.small': '0',
        'typography.letter-spacing.body.x-large': '0',
        'typography.letter-spacing.body.x-small': '0',
        'typography.letter-spacing.header.display 1': '0',
        'typography.letter-spacing.header.display 2': '0',
        'typography.letter-spacing.header.large': '0',
        'typography.letter-spacing.header.medium': '0',
        'typography.letter-spacing.header.small': '0',
        'typography.letter-spacing.header.x-small': '0',
      },
      styles: {
        header: {
          'display-2': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '900',
              fontSize: '56',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'display-1': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '900',
              fontSize: '48',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          large: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '40',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '40', letterSpacing: '0', lineHeight: 'normal' },
          },
          medium: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '32',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'medium-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '32', letterSpacing: '0', lineHeight: 'normal' },
          },
          small: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '28',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'small-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '28', letterSpacing: '0', lineHeight: 'normal' },
          },
          'x-small': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '24',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '24', letterSpacing: '0', lineHeight: 'normal' },
          },
        },
        body: {
          'x-large': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-large-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          large: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          base: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          small: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'small-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
        },
        caption: {
          caption: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '10',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'caption-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '10',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'caption-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '10',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
        },
        link: {
          'link-large': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-base': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-small': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
        },
      },
    },
    large: {
      brand: 'default',
      mode: 'dark',
      breakpoint: 'large',
      colors: {
        black: '#161616',
        'border.brand': '#B8ECE0',
        'border.brand-alt': '#005A5D',
        'border.disabled': '#25252629',
        'border.divider': '#FEFEFD33',
        'border.error': '#FD6C6F',
        'border.focused': '#B8ECE0',
        'border.info': '#5C9CEF',
        'border.interactive': '#45D3BC',
        'border.inverse.disabled': '#25252666',
        'border.inverse.divider': '#2525261F',
        'border.inverse.interactive': '#1EB8A6',
        'border.inverse.primary': '#25252666',
        'border.inverse.secondary': '#25252629',
        'border.inverse.selected': '#08817D',
        'border.inverse.strong': '#161616',
        'border.primary': '#FEFEFD66',
        'border.secondary': '#FEFEFD29',
        'border.secondary-1.default': '#96DF3C',
        'border.secondary-1.strong': '#F6FDE8',
        'border.secondary-1.subtle': '#457714',
        'border.secondary-2.default': '#E8C427',
        'border.secondary-2.strong': '#FCFBEA',
        'border.secondary-2.subtle': '#956213',
        'border.secondary-3.default': '#FFAD54',
        'border.secondary-3.strong': '#FFF8ED',
        'border.secondary-3.subtle': '#C64C08',
        'border.secondary-4.default': '#FFBABC',
        'border.secondary-4.strong': '#FFF7F7',
        'border.secondary-4.subtle': '#9F6B6E',
        'border.secondary-5.default': '#B3B8FF',
        'border.secondary-5.strong': '#F6F7FF',
        'border.secondary-5.subtle': '#666AA0',
        'border.selected': '#009597',
        'border.strong': '#FFFFFF',
        'border.success': '#96DF3C',
        'border.warning': '#E8C427',
        'component.button.bg.hover': '#FEFEFD33',
        'component.button.bg.inverted': '#161616',
        'component.button.bg.pressed': '#25252666',
        'component.button.bg.primary': '#036D6D',
        'component.button.bg.secondary': '#B8ECE0',
        'component.button.bg.tertiary': '#3B3A3C',
        'component.button.bg.transparent': '#FEFEFD66',
        'component.button.border.tertiary': '#FFFFFF',
        'component.button.icon.tertiary': '#B8ECE0',
        'component.button.label.tertiary': '#B8ECE0',
        'gradient.Bottom Tab Bar - End': '#161616E5',
        'gradient.Bottom Tab Bar - Start': '#16161600',
        'gradient.primary': '#16161600',
        'icon.brand': '#B8ECE0',
        'icon.brand-alt': '#005A5D',
        'icon.disabled': '#FEFEFD66',
        'icon.error': '#FD6C6F',
        'icon.info': '#85B5F3',
        'icon.interactive': '#45D3BC',
        'icon.inverse.disabled': '#25252666',
        'icon.inverse.interactive': '#1EB8A6',
        'icon.inverse.primary': '#161616',
        'icon.inverse.secondary': '#676666',
        'icon.primary': '#FFFFFF',
        'icon.secondary': '#C1C0BC',
        'icon.secondary-1.default': '#96DF3C',
        'icon.secondary-1.strong': '#F6FDE8',
        'icon.secondary-1.subtle': '#325017',
        'icon.secondary-2.default': '#E8C427',
        'icon.secondary-2.strong': '#FCFBEA',
        'icon.secondary-2.subtle': '#6A4019',
        'icon.secondary-3.default': '#FFAD54',
        'icon.secondary-3.strong': '#FFF8ED',
        'icon.secondary-3.subtle': '#7E3410',
        'icon.secondary-4.default': '#FFBABC',
        'icon.secondary-4.strong': '#FFF7F7',
        'icon.secondary-4.subtle': '#3E2D30',
        'icon.secondary-5.default': '#B3B8FF',
        'icon.secondary-5.strong': '#F6F7FF',
        'icon.secondary-5.subtle': '#2B2C41',
        'icon.success': '#96DF3C',
        'icon.tertiary': '#676666',
        'icon.warning': '#EDD441',
        page: '#161616',
        'shadow.inner': '#FEFEFD33',
        'shadow.strong': '#25252629',
        'shadow.subtle': '#25252614',
        'state-layer.hover': '#FEFEFD14',
        'state-layer.hover-alt': '#25252629',
        'state-layer.hover-brand': '#B8ECE029',
        'state-layer.hover-on-color': '#FEFEFD33',
        'state-layer.inverse.hover': '#25252614',
        'state-layer.inverse.hover-brand': '#B8ECE033',
        'state-layer.inverse.hover-on-color': '#FEFEFD33',
        'state-layer.inverse.press': '#25252629',
        'state-layer.inverse.press-brand': '#B8ECE066',
        'state-layer.inverse.press-on-color': '#25252666',
        'state-layer.press': '#FEFEFD29',
        'state-layer.press-alt': '#25252666',
        'state-layer.press-brand': '#B8ECE066',
        'state-layer.press-on-color': '#FEFEFD66',
        'surface.brand.bold': '#D9F2EB',
        'surface.brand.bold-alt': '#BDFDFF',
        'surface.brand.default': '#45D3BC',
        'surface.brand.secondary-1.default': '#96DF3C',
        'surface.brand.secondary-1.strong': '#F6FDE8',
        'surface.brand.secondary-1.subtle': '#325017',
        'surface.brand.secondary-2.default': '#E8C427',
        'surface.brand.secondary-2.strong': '#FCFBEA',
        'surface.brand.secondary-2.subtle': '#6A4019',
        'surface.brand.secondary-3.default': '#FFAD54',
        'surface.brand.secondary-3.strong': '#FFF8ED',
        'surface.brand.secondary-3.subtle': '#7E3410',
        'surface.brand.secondary-4.default': '#FFBABC',
        'surface.brand.secondary-4.strong': '#FFF7F7',
        'surface.brand.secondary-4.subtle': '#3E2D30',
        'surface.brand.secondary-5.default': '#B3B8FF',
        'surface.brand.secondary-5.strong': '#F6F7FF',
        'surface.brand.secondary-5.subtle': '#2B2C41',
        'surface.brand.strong': '#D9F2EB',
        'surface.brand.strong-alt': '#ECFFFE',
        'surface.brand.subtle': '#08817D',
        'surface.default': '#252526',
        'surface.disabled': '#FEFEFD33',
        'surface.error.default': '#FD6C6F',
        'surface.error.subtle': '#F53E4233',
        'surface.info.default': '#5C9CEF',
        'surface.info.subtle': '#3383EB33',
        'surface.inverse.default': '#FFFFFF',
        'surface.inverse.disabled': '#25252633',
        'surface.inverse.primary-neutral': '#959492',
        'surface.inverse.secondary-neutral': '#676666',
        'surface.inverse.tertiary-neutral': '#3B3A3C',
        'surface.overlay': '#25252666',
        'surface.primary': '#003133',
        'surface.primary-alt': '#00393D',
        'surface.primary-neutral': '#252526',
        'surface.secondary': '#005A5D',
        'surface.secondary-alt': '#005A5D',
        'surface.secondary-neutral': '#3B3A3C',
        'surface.selected': '#003133',
        'surface.strong-neutral': '#EEECE7',
        'surface.success.default': '#77C41E',
        'surface.success.subtle': '#77C41E33',
        'surface.tertiary': '#036D6D',
        'surface.tertiary-alt': '#007377',
        'surface.tertiary-neutral': '#676666',
        'surface.warning.default': '#E8C427',
        'surface.warning.subtle': '#D8AD1A33',
        'text.brand': '#B8ECE0',
        'text.brand-alt': '#005A5D',
        'text.disabled': '#FEFEFD66',
        'text.emphasized': '#45D3BC',
        'text.error': '#FD6C6F',
        'text.info': '#85B5F3',
        'text.interactive': '#45D3BC',
        'text.inverse.disabled': '#25252666',
        'text.inverse.interactive': '#1EB8A6',
        'text.inverse.primary': '#252526',
        'text.inverse.secondary': '#676666',
        'text.placeholder': '#959492',
        'text.positive': '#96DF3C',
        'text.primary': '#FFFFFF',
        'text.secondary': '#C1C0BC',
        'text.secondary-1.default': '#96DF3C',
        'text.secondary-1.strong': '#F6FDE8',
        'text.secondary-1.subtle': '#325017',
        'text.secondary-2.default': '#E8C427',
        'text.secondary-2.strong': '#FCFBEA',
        'text.secondary-2.subtle': '#6A4019',
        'text.secondary-3.default': '#FFAD54',
        'text.secondary-3.strong': '#FFF8ED',
        'text.secondary-3.subtle': '#7E3410',
        'text.secondary-4.default': '#FFBABC',
        'text.secondary-4.strong': '#FFF7F7',
        'text.secondary-4.subtle': '#3E2D30',
        'text.secondary-5.default': '#B3B8FF',
        'text.secondary-5.strong': '#F6F7FF',
        'text.secondary-5.subtle': '#2B2C41',
        'text.warning': '#EDD441',
        white: '#FFFFFF',
        'white-label.accent.icon.on-brand-accent': '#FFFFFF',
        'white-label.accent.surface': '#005A5D',
        'white-label.accent.text.on-brand-accent': '#FFFFFF',
        'white-label.footer.footer-bg': '#161616',
        'white-label.header.bg': '#161616',
        'white-label.header.on-header': '#FFFFFF',
        'white-label.headerSubtext': '#FFFFFF',
        'white-label.highlight': '#FFFFFF',
        'white-label.highlightText': '#FFFFFF',
        'white-label.notificationLogoBackground': '#FFFFFF',
        'white-label.publish-button.bg.header-bar': '#005A5D',
        'white-label.publish-button.bg.mobile-bottom-tab-bar': '#005A5D',
        'white-label.publish-button.icon.header-bar': '#FFFFFF',
        'white-label.publish-button.icon.mobile-bottom-tab-bar': '#FFFFFF',
        'white-label.publish-button.label.primary': '#FFFFFF',
        'white-label.splash': '#B8ECE0',
      },
      responsive: {
        'border-width.bold': '4',
        'border-width.emphasized': '2',
        'border-width.standard': '1.5',
        'border-width.subtle': '1',
        'radius.component.fields.input': '16',
        'radius.component.publish-button.button-radius': '1000',
        'radius.full': '1000',
        'radius.lg': '16',
        'radius.md': '12',
        'radius.none': '0',
        'radius.sm': '8',
        'radius.xl': '24',
        'radius.xs': '4',
        'radius.xxl': '32',
        'radius.xxs': '2',
        'sizing.body.max-width': '1320',
        'sizing.body.min-width': '1280',
        'sizing.component.button.height.large': '56',
        'sizing.component.button.height.large-icn-button': '48',
        'sizing.component.button.height.medium': '40',
        'sizing.component.button.height.small': '32',
        'sizing.component.header.max-width': '1920',
        'sizing.component.header.min-width': '1280',
        'sizing.general.0': '0',
        'sizing.general.x0,25': '1',
        'sizing.general.x0,5': '2',
        'sizing.general.x1': '4',
        'sizing.general.x10': '40',
        'sizing.general.x100': '400',
        'sizing.general.x12': '48',
        'sizing.general.x120': '480',
        'sizing.general.x14': '56',
        'sizing.general.x140': '560',
        'sizing.general.x150': '600',
        'sizing.general.x16': '64',
        'sizing.general.x160': '640',
        'sizing.general.x18': '72',
        'sizing.general.x180': '720',
        'sizing.general.x2': '8',
        'sizing.general.x20': '80',
        'sizing.general.x200': '800',
        'sizing.general.x22': '88',
        'sizing.general.x24': '96',
        'sizing.general.x3': '12',
        'sizing.general.x30': '120',
        'sizing.general.x36': '144',
        'sizing.general.x4': '16',
        'sizing.general.x40': '160',
        'sizing.general.x5': '20',
        'sizing.general.x50': '200',
        'sizing.general.x6': '24',
        'sizing.general.x60': '240',
        'sizing.general.x7': '28',
        'sizing.general.x70': '280',
        'sizing.general.x8': '32',
        'sizing.general.x80': '320',
        'sizing.general.x90': '360',
        'sizing.icon.default': '24',
        'sizing.icon.lg': '32',
        'sizing.icon.s': '16',
        'sizing.icon.sm': '20',
        'sizing.icon.xl': '48',
        'sizing.icon.xs': '12',
        'spacing.general.0': '0',
        'spacing.general.x0,5': '2',
        'spacing.general.x1': '4',
        'spacing.general.x10': '40',
        'spacing.general.x12': '48',
        'spacing.general.x14': '56',
        'spacing.general.x16': '64',
        'spacing.general.x18': '72',
        'spacing.general.x2': '8',
        'spacing.general.x20': '80',
        'spacing.general.x22': '88',
        'spacing.general.x24': '96',
        'spacing.general.x3': '12',
        'spacing.general.x30': '120',
        'spacing.general.x36': '144',
        'spacing.general.x4': '16',
        'spacing.general.x5': '20',
        'spacing.general.x6': '24',
        'spacing.general.x7': '28',
        'spacing.general.x8': '32',
        'spacing.semantic.line-height-fix': '2',
        'spacing.semantic.page-margin': '48',
        'typography.font-size.body.base': '16',
        'typography.font-size.body.caption': '10',
        'typography.font-size.body.large': '18',
        'typography.font-size.body.small': '14',
        'typography.font-size.body.x-large': '20',
        'typography.font-size.body.x-small': '12',
        'typography.font-size.header.display 1': '56',
        'typography.font-size.header.display 2': '64',
        'typography.font-size.header.large': '48',
        'typography.font-size.header.medium': '40',
        'typography.font-size.header.small': '36',
        'typography.font-size.header.x-small': '32',
        'typography.font-size.link.link-base': '16',
        'typography.font-size.link.link-large': '20',
        'typography.font-size.link.link-small': '14',
        'typography.letter-spacing.body.base': '0',
        'typography.letter-spacing.body.caption': '0',
        'typography.letter-spacing.body.large': '0',
        'typography.letter-spacing.body.small': '0',
        'typography.letter-spacing.body.x-large': '0',
        'typography.letter-spacing.body.x-small': '0',
        'typography.letter-spacing.header.display 1': '0',
        'typography.letter-spacing.header.display 2': '0',
        'typography.letter-spacing.header.large': '0',
        'typography.letter-spacing.header.medium': '0',
        'typography.letter-spacing.header.small': '0',
        'typography.letter-spacing.header.x-small': '0',
      },
      styles: {
        header: {
          'display-2': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '900',
              fontSize: '64',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'display-1': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '900',
              fontSize: '56',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          large: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '48',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '48', letterSpacing: '0', lineHeight: 'normal' },
          },
          medium: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '40',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'medium-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '40', letterSpacing: '0', lineHeight: 'normal' },
          },
          small: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '36',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'small-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '36', letterSpacing: '0', lineHeight: 'normal' },
          },
          'x-small': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '32',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-strong': {
            $type: 'typography',
            $value: { fontFamily: 'Inter', fontSize: '32', letterSpacing: '0', lineHeight: 'normal' },
          },
        },
        body: {
          'x-large': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-large-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          large: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'large-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '18',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          base: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'base-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          small: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'small-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'x-small-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '12',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
        },
        caption: {
          caption: {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '10',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'caption-medium': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '600',
              fontSize: '10',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
          'caption-strong': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '700',
              fontSize: '10',
              letterSpacing: '0',
              lineHeight: 'normal',
            },
          },
        },
        link: {
          'link-large': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '20',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-base': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '16',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
          'link-small': {
            $type: 'typography',
            $value: {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '14',
              letterSpacing: '0',
              lineHeight: 'normal',
              textDecoration: 'underline',
            },
          },
        },
      },
    },
  },
} as const;
